<template>
    <div>
        <li class="m_li" @mouseleave="onMouseOut($event)" @mouseenter="onMouseOver($event)">
            <a href="javascript:;" class="f r_ma" style="color:#ffffff;font-size:22px;"></a>
            <p class="r_av m_tr" id="m_fma" :style="active">
                <img src="../../assets/image/minapp_qw.jpg" width="120" height="137">
                <em class="r_vt">◆</em>
            </p>
        </li>
    </div>
</template>

<script>
export default{
    data(){
        return{
            active:"",
        }
    },
    methods:{
        onMouseOver($event){
            $event.currentTarget.className="m_li m_lion";
            this.active="opacity: 1; right: 35px; display: block;"
        },
        onMouseOut($event){
            $event.currentTarget.className="m_li";
            this.active="opacity: 0; right: 70px; display: none;"
        },
    },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/right-code.vue